import {useEffect, useState} from 'react';

import {AnyActor, Snapshot} from 'xstate';

import {isDevelopmentMode} from 'config/staticConfig';
import {
  APP_LOCAL_STORAGE_X_STATE_INSPECT_ENABLED,
  APP_LOCAL_STORAGE_X_STATE_SNAPSHOTS_ENABLED
} from 'shared/Storage/constants/localStorageKeys';

export const initializeXStateDevTools = () => {
  if (isDevelopmentMode && xStateInspectEnabled()) {
    import('@statelyai/inspect').then(({createBrowserInspector}) => {
      // @ts-ignore
      window.xStateInspect = createBrowserInspector({});
    });
  }
};

export const xStateInspectEnabled = () =>
  window.localStorage.getItem(APP_LOCAL_STORAGE_X_STATE_INSPECT_ENABLED) === 'true';
export const toggleXStateInspect = () => {
  window.localStorage.setItem(APP_LOCAL_STORAGE_X_STATE_INSPECT_ENABLED, (!xStateInspectEnabled()).toString());
  initializeXStateDevTools();
};

// @ts-ignore
export const inspect = () => (xStateInspectEnabled() ? window.xStateInspect.inspect : undefined);

export const useWriteSnapshotsOut = (actor: AnyActor) => {
  const [registered, setRegistered] = useState(false);
  useEffect(() => {
    isDevelopmentMode && writeSnapshotFile(actor.getPersistedSnapshot()); //trigger on machine creation
  }, [actor]);
  useEffect(() => {
    if (registered || !isDevelopmentMode) {
      return; //only register the onTransition effect once
    }
    actor.subscribe(() => {
      writeSnapshotFile(actor.getPersistedSnapshot());
    });
    setRegistered(true);
  }, [registered, actor]);
};

const generateFileName = (snapshot: Snapshot<unknown>) => {
  //@ts-ignore
  const stateValue = snapshot.value;
  if (!stateValue) {
    throw Error();
  }
  const fileName = JSON.stringify(stateValue).replaceAll(/[{}"]/g, '').replaceAll(':', '.');
  return `${fileName}-${Date.now()}.json`;
};

const writeSnapshotFile = (snapshot: Snapshot<unknown>) => {
  if (!xStateSnapshotsEnabled()) {
    return;
  }
  const element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(JSON.stringify(snapshot)));

  element.setAttribute('download', generateFileName(snapshot));
  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
};

export const xStateSnapshotsEnabled = () =>
  window.localStorage.getItem(APP_LOCAL_STORAGE_X_STATE_SNAPSHOTS_ENABLED) === 'true';
export const toggleXStateSnapshots = () => {
  window.localStorage.setItem(APP_LOCAL_STORAGE_X_STATE_SNAPSHOTS_ENABLED, (!xStateSnapshotsEnabled()).toString());
};
